<template>
  <v-dialog v-model="is_DaySetModal" max-width="500px">
    <v-card class="message-day-setting">
      <v-card-title class="pt-5 pl-5 pb-1 font-weight-bold">보증 기간 만료 {{ day_type_text() }} - 발송일시 설정</v-card-title>
      <v-card-text class="pl-5 pb-0">
        발송일시를 최대 10개까지 추가하여 설정할 수 있습니다.
      </v-card-text>

      <v-card-text>
        <v-row class="mt-3">
          <v-col
            cols="12"
            row
            v-for="(config, index) in set_day_config"
            :key="index"
            class="d-flex justify-space-between mb-2 align-center py-0 pl-3"
          >
            <v-select
              v-model="config.day"
              :items="day_list"
              class="mr-2"
              cols="3"
              outlined
              dense
              hide-details="true"
              placeholder="발송일 선택"
              :style="{ width: '285px' }"
            ></v-select>
            <v-select
              v-model="config.time"
              :items="time_list"
              class="mr-2"
              cols="3"
              outlined
              dense
              hide-details="true"
              placeholder="시간 선택"
              :style="{ width: '260px' }"
            ></v-select>
            <v-select
              v-model="config.minute"
              :items="minute_list"
              class="mr-2"
              outlined
              dense
              hide-details="true"
              placeholder="분 선택"
              :style="{ width: '260px' }"
            ></v-select>
            <v-btn v-if="index === 0" outlined @click="addConfig" class="plus-btn"><v-icon>mdi-plus</v-icon></v-btn>
            <v-btn v-else outlined class="minus-btn" @click="removeConfig(index)">
              <v-icon>mdi-minus</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-card-actions class="d-flex justify-space-between mt-3 pa-0">
          <div style="width:49%;">
            <v-btn color="grey darken-4" block class="white--text" @click="is_DaySetModal = false">닫기</v-btn>
          </div>
          <div style="width:49%;">
            <v-btn color="blue darken-1" block class="white--text" @click="setDayType">설정하기</v-btn>
          </div>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style scoped>
.plus-btn,
.minus-btn {
  height: 40px !important;
  width: 40px !important;
  min-width: 24px !important;
  background-color: #f1f1f1;
  border-color: #d6d6d6;
}

.plus-btn:hover,
.minus-btn:hover {
  border-color: black;
}
</style>

<script>
import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin";
export default {
  data() {
    return {
      is_DaySetModal: false,
      day_type: "before",
      real_type: null,
      day_list: Array.from({ length: 30 }, (_, i) => ({ text: `${i + 1}일 ${this.day_type_text()}`, value: i + 1 })),
      time_list: Array.from({ length: 24 }, (_, i) => ({
        text: `${i}시`,
        value: i.toString().padStart(2, "0"),
      })),
      minute_list: [
        { text: "00분", value: "00" },
        { text: "30분", value: "30" },
      ],
      set_day_config: [
        {
          day: "",
          time: "",
          minute: "",
        },
      ],
      new_day_config: {
        day: "",
        time: "",
        minute: "",
      },
    };
  },
  methods: {
    removeConfig(index) {
      this.set_day_config.splice(index, 1);
    },
    async getDayType() {
      // console.log("get Day Type", this.day_type);
      try {
        const res = await M.api(M.entry("/get/config/message/add_info"), {
          msg_type: this.real_type,
        });
        // console.log("get Day Type result", res);
        if (res) {
          if (res.set_day_config.length > 0) {
            this.set_day_config = [];
            for (let i = 0; i < res.set_day_config.length; i++) {
              let day = res.set_day_config[i].day;
              let time = res.set_day_config[i].time;
              let minute = time.split(":")[1];
              time = time.split(":")[0];
              this.set_day_config.push({ day: day, time: time, minute: minute });
            }
          } else {
            this.set_day_config = [{ day: "", time: "", minute: "" }];
          }
        }
      } catch (error) {
        this.set_day_config = [{ day: "", time: "", minute: "" }];
        console.log(error);
      }
      return this.day_type;
    },
    openDaySettingModal(type) {
      if (type === "expired_before") {
        this.day_type = "before";
      } else if (type === "expired_after") {
        this.day_type = "after";
      }
      this.real_type = type;
      this.resetSetting();
      this.getDayType();
      this.set_day_option_list();
      this.is_DaySetModal = true;
    },
    resetSetting() {
      this.set_day_config = [
        {
          day: "",
          time: "",
          minute: "",
        },
      ];
    },
    set_day_option_list() {
      this.day_list = Array.from({ length: 30 }, (_, i) => ({ text: `${i + 1}일 ${this.day_type_text()}`, value: i + 1 }));
    },
    addConfig() {
      if (this.set_day_config.length >= 10) {
        this.alertShow("최대 10개까지 설정 가능합니다.");
        return;
      }
      /*
      if (!this.day_list.some(day => day.value === this.new_day_config.day)) {
        alert("발송일을 선택해주세요.");
        return;
      }
      if (!this.time_list.some(time => time.value === this.new_day_config.time)) {
        alert("시간을 선택해주세요.");
        return;
      }
      if (!this.minute_list.some(minute => minute.value === this.new_day_config.minute)) {
        alert("분을 선택해주세요.");
        return;
      }
      if (this.set_day_config.some(config => config.day === this.new_day_config.day && config.time === this.new_day_config.time && config.minute === this.new_day_config.minute)) {
        alert("중복된 설정이 있습니다.");
        return;
      }
        */
      this.set_day_config.push({ ...this.new_day_config });
    },
    day_type_text() {
      return this.day_type === "before" ? "전" : "후";
    },
    async setDayType() {
      // console.log("validate start", this.day_type);
      let check = [];
      let set_day = [];
      for (let i = 0; i < this.set_day_config.length; i++) {
        let check_day = this.set_day_config[i].day;
        let check_time = this.set_day_config[i].time;
        let check_minute = this.set_day_config[i].minute;
        if (!this.day_list.some((day) => day.value === check_day)) {
          this.alertShow("발송일을 선택해주세요.");
          return;
        }
        if (!this.time_list.some((time) => time.value === check_time)) {
          this.alertShow("시간을 선택해주세요.");
          return;
        }
        if (!this.minute_list.some((minute) => minute.value === check_minute)) {
          this.alertShow("분을 선택해주세요.");
          return;
        }
        let check_str = `${check_day}-${check_time}-${check_minute}`;
        if (check.includes(check_str)) {
          this.alertShow("중복된 설정이 있습니다.");
          return;
        } else {
          set_day.push({ day: check_day, time: check_time + ":" + check_minute });
        }
        check.push(check_str);
      }
      // console.log("save days", set_day);

      try {
        const res = await M.api(M.entry("/put/config/message/add_info"), {
          msg_type: this.real_type,
          set_day_config: set_day,
        });
        // console.log("set Day Type result", res);
        if (res) {
          if (res.set_day_config.length === this.set_day_config.length) {
            this.alertShow("설정이 완료되었습니다.");
            this.is_DaySetModal = false;
          }
          // console.log("get data");
        }
      } catch (error) {
        console.log(error);
      }
      //this.$emit("changeUseSetting", this.switchValue);
    },
  },
  mixins: [CommonMixin],
};
</script>
